import React, { useRef, useState } from "react";
import { Button, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import useGetUrlLocale from "../../../../hooks/useGetUrlLocale";
import DomainConnectInfo from "../../../newProject/domainSetup/domainConnectView/DomainConnectInfo";
import VerifyingInfo from "../../../newProject/domainSetup/verifyingInfoView/VerifyingInfo";
import StepsInfo from "../../../newProject/StepsInfo";
import DomainName from "./DomainName";

export default function AddDomainSteps() {
  const { t } = useTranslation();
  const lng = useGetUrlLocale();
  const { id } = useParams();
  const navigate = useNavigate();
  const userDomain = useRef<string>("");

  const [step, setStep] = useState(1);

  const isSubdomainMode = window.location.href.includes("add-subdomain");

  const handleVerify = () => {
    navigate(`${lng}/projects/${id}/edit`);
  };

  return (
    <>
      <StepsInfo
        step={step}
        stepNames={[
          t("projects.Domain Name"),
          t("projects.Setup & Connect"),
          t("projects.Complite Setup"),
        ]}
        className="mb-md-5 mx-auto col-lg-9"
      />
      {step === 1 && (
        <DomainName
          setStep={setStep}
          domainId={+id}
          isSubdomainMode={isSubdomainMode}
          userDomain={userDomain}
        />
      )}
      {step === 2 && (
        <div className="mt-4 mt-md-0">
          <DomainConnectInfo
            userDomain={userDomain.current}
            handleBack={() => setStep(1)}
            handleVerify={() => setStep(3)}
            isSubdomainMode={isSubdomainMode}
          />
        </div>
      )}
      {step === 3 && (
        <div className="mt-4 mt-md-0">
          <VerifyingInfo>
            <Col md={8} lg={6} className="mx-auto mt-4">
              <Button
                variant="primary"
                className="w-100 text-white fw-bold order-0 order-lg-1"
                onClick={handleVerify}
              >
                {t("projects.Verify Status")}
              </Button>
            </Col>
          </VerifyingInfo>
        </div>
      )}
    </>
  );
}
